import { render, staticRenderFns } from "./simpleMenu.vue?vue&type=template&id=7ae12cd4&"
import script from "./simpleMenu.vue?vue&type=script&lang=js&"
export * from "./simpleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderComponent: require('/usr/src/app/components/HeaderComponent.vue').default,FormPopup: require('/usr/src/app/components/FormPopup.vue').default})
